// @ts-nocheck

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import AccessRestriction from '../AccessRestriction/AccessRestriction'
import { colors } from '@lmc/common/constants'
import { DropdownMenu } from '../DropdownMenu'
import ListItem from '../ListItem'
import calendar from 'dayjs/plugin/calendar'

dayjs.extend(calendar)
export default class DocumentItem extends Component<any, any> {
  hiddenLink = null

  setHiddenLink = (node) => (this.hiddenLink = node)

  handleDelete = () => {
    const { data, onDelete } = this.props
    onDelete(data.id)
  }

  handleEdit = () => {
    const { data, onEdit } = this.props
    onEdit(data)
  }

  handleView = () => this.hiddenLink.click()

  render() {
    const { data, readOnly, type } = this.props

    const daysDiff = dayjs().diff(data.createdAt, 'days')
    const displayedTime =
      daysDiff <= 7
        ? dayjs(data.createdAt).calendar()
        : `Added ${daysDiff} days ago`

    const label =
      data.name.length > 100 ? `${data.name.substring(0, 100)}...` : data.name

    return (
      <ListItem
        svgIcon="document"
        iconColor={colors.darkblue}
        inlineChildren
        label={label}
        multiSelect
        onSelect={type === 'edit' ? this.handleEdit : this.handleView}
        subLabel={displayedTime}
        carePlanName={data.carePlanName}
        iconSize={24}
        size={40}
        hasBorder
      >
        <div style={styles.actionsContainer}>
          <AccessRestriction>
            {!readOnly && (
              <DropdownMenu
                items={[
                  {
                    label: 'View',
                    onClick: this.handleView,
                  },
                  {
                    label: 'Edit',
                    onClick: this.handleEdit,
                  },
                  {
                    label: 'Delete',
                    onClick: this.handleDelete,
                  },
                ]}
                buttonStyle={styles.menuIcon}
                menuStyle={styles.menuContainer}
              />
            )}
          </AccessRestriction>
          <a
            href={data.originalFile || data.pdf}
            ref={this.setHiddenLink}
            rel="noreferrer"
            style={styles.hiddenLink}
            target="_blank"
          >
            {' '}
          </a>
        </div>
      </ListItem>
    )
  }
}

const styles = {
  actionsContainer: {
    alignItems: 'center',
    display: 'flex',
    position: 'relative',
  },
  hiddenLink: {
    left: -9999,
    position: 'absolute',
  },
  menuContainer: {
    position: 'absolute',
    top: 25,
    right: '-13px',
  },
  menuIcon: {
    alignItems: 'center',
    display: 'flex',
  },
}

DocumentItem.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  readOnly: PropTypes.bool,
}
